import { ASSETS_API_URL } from "config/api";
import { showApiError, showFormError } from "config/apiToast";
import React, { useState } from "react";
import axios from 'axios';
import "./dashboard.scss";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
const Addtoken = () => {

  const history = useHistory();
  const [chainName, setChainName] = useState("");
  const [chainID, setChainID] = useState("");
  const [chainExplorer, setChainExplorer] = useState("");
  const [rpcURL, setRpcURL] = useState("");
  const [standard, setStandard] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEssential, setIsEssential] = useState(false);
  const [tokenIcon, setTokenIcon] = useState(null);
  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let newErrors = { ...errors };

    switch (id) {
      case "chainName":
        setChainName(value);
        if (value) {
          delete newErrors.chainName;
        }
        break;
      case "chainID":
        setChainID(value);
        if (value) {
          delete newErrors.chainID;
        }
        break;
      case "chainExplorer":
        setChainExplorer(value);
        if (value) {
          delete newErrors.chainExplorer;
        }
        break;
      case "rpcURL":
        setRpcURL(value);
        if (value) {
          delete newErrors.rpcURL;
        }
        break;
      case "standard":
        setStandard(value);
        if (value) {
          delete newErrors.standard;
        }
        break;
      default:
        break;
    }

    setErrors(newErrors);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let newErrors = { ...errors };
      delete newErrors.tokenIcon;
      setErrors(newErrors);
      setTokenIcon(file);
      setPreview(URL.createObjectURL(file));

    }
  };

  const handleSubmit = async () => {
    let tok = localStorage.getItem("accessTokenDash");
    let formErrors = {};
    if (!tokenIcon) formErrors.tokenIcon = "Token icon is required";
    if (!chainName) formErrors.chainName = "Chain name is required";
    if (!chainID) formErrors.chainID = "Chain ID is required";
    if (!chainExplorer) formErrors.chainExplorer = "Chain explorer is required";
    if (!standard) formErrors.standard = "Standard is required";
    if (!rpcURL) formErrors.rpcURL = "RPC URL is required";
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      showFormError();
      return;
    }

    const formData = new FormData();
    formData.append("logo", tokenIcon);
    formData.append("name", chainName);
    formData.append("chainId", chainID);
    formData.append("chainExplorer", chainExplorer);
    formData.append("standard", standard);
    formData.append("rpcUrl", rpcURL);
    formData.append("isEnabled", isEnabled);
    formData.append("isEssential", isEssential);
    var config = {
      method: "POST",
      url: `${ASSETS_API_URL}/chains`,
      headers: {
        authorization: `Bearer ` + tok
      },
      data: formData,
    };
    axios(config)
      .then(function (response) {
        toast
        .success("Chain Added Successfully", {
            position: "top-right",
            autoClose: 3000,
        })
        setChainName("");
        setChainID("");
        setChainExplorer("");
        setStandard("");
        setRpcURL("");
        setIsEnabled(false);
        setIsEssential(false);
        setTokenIcon(null);
        setPreview(null);
        history.push("dashboard");

        // console.log("response we get", response)
      })
      .catch(function (error) {
        showApiError(error);
      });
  }
  return (
    <>
      <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
      <div className="content">
        <div className="tokenicon">
          <p className="para1">Chain Icon</p>
          <div className="headparent">
            <div className='maininput'>
              <label htmlFor='upload'>

                <div className='wrapper'>

                  {preview ?
                    (
                      <img src={preview} alt="Token Icon Preview" className="preview shcvsdghvdhc" />
                    )
                    :
                    (
                      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="47" viewBox="0 0 46 47" fill="none" className='cursorrrr'>
                        <path d="M17.2501 21.1042C14.3367 21.1042 11.9792 18.7467 11.9792 15.8333C11.9792 12.92 14.3367 10.5625 17.2501 10.5625C20.1634 10.5625 22.5209 12.92 22.5209 15.8333C22.5209 18.7467 20.1634 21.1042 17.2501 21.1042ZM17.2501 13.4375C15.9276 13.4375 14.8542 14.5108 14.8542 15.8333C14.8542 17.1558 15.9276 18.2292 17.2501 18.2292C18.5726 18.2292 19.6459 17.1558 19.6459 15.8333C19.6459 14.5108 18.5726 13.4375 17.2501 13.4375Z" fill="#232323" />
                        <path d="M28.7499 44.1041H17.2499C6.84242 44.1041 2.39575 39.6574 2.39575 29.2499V17.7499C2.39575 7.34242 6.84242 2.89575 17.2499 2.89575H24.9166C25.7024 2.89575 26.3541 3.54742 26.3541 4.33325C26.3541 5.11909 25.7024 5.77075 24.9166 5.77075H17.2499C8.41408 5.77075 5.27075 8.91408 5.27075 17.7499V29.2499C5.27075 38.0858 8.41408 41.2291 17.2499 41.2291H28.7499C37.5858 41.2291 40.7291 38.0858 40.7291 29.2499V19.6666C40.7291 18.8808 41.3808 18.2291 42.1666 18.2291C42.9524 18.2291 43.6041 18.8808 43.6041 19.6666V29.2499C43.6041 39.6574 39.1574 44.1041 28.7499 44.1041Z" fill="#232323" />
                        <path d="M40.7292 11.5208H30.1875C29.4017 11.5208 28.75 10.8691 28.75 10.0833C28.75 9.29742 29.4017 8.64575 30.1875 8.64575H40.7292C41.515 8.64575 42.1667 9.29742 42.1667 10.0833C42.1667 10.8691 41.515 11.5208 40.7292 11.5208Z" fill="#232323" />
                        <path d="M35.4583 16.7917C34.6724 16.7917 34.0208 16.14 34.0208 15.3542V4.8125C34.0208 4.02667 34.6724 3.375 35.4583 3.375C36.2441 3.375 36.8958 4.02667 36.8958 4.8125V15.3542C36.8958 16.14 36.2441 16.7917 35.4583 16.7917Z" fill="#232323" />
                        <path d="M5.11741 38.2582C4.65741 38.2582 4.19741 38.0282 3.92908 37.6257C3.48824 36.9741 3.66074 36.0732 4.31241 35.6324L13.7616 29.2882C15.8316 27.9082 18.6874 28.0616 20.5657 29.6524L21.1982 30.2082C22.1566 31.0324 23.7857 31.0324 24.7249 30.2082L32.6982 23.3657C34.7491 21.6216 37.9307 21.6216 39.9816 23.3657L43.1057 26.0491C43.6999 26.5666 43.7766 27.4674 43.2591 28.0807C42.7416 28.6749 41.8407 28.7516 41.2274 28.2341L38.1032 25.5507C37.1449 24.7266 35.5157 24.7266 34.5766 25.5507L26.6032 32.3932C24.5716 34.1374 21.3707 34.1374 19.3199 32.3932L18.6874 31.8374C17.8057 31.0899 16.3491 31.0132 15.3716 31.6841L5.94158 38.0282C5.67324 38.1816 5.38574 38.2582 5.11741 38.2582Z" fill="#232323" />
                      </svg>
                    )
                  }

                  <p className='gray'>
                    Add Token Icon Image
                    <br></br>
                    Supports: JPG, JPEG, PNG
                  </p>
                  <input type='file' id='upload' accept="image/png, image/jpeg, image/jpg" className='d-none' onChange={handleImageChange} />
                  {errors.tokenIcon && <p className="error">{errors.tokenIcon}</p>}
                </div>
              </label>
            </div>
          </div>
          <div className="mainparent2">
            <p className="inputtextttt">Chain Name</p>
            <input type="text" placeholder="Chain Name" className="inputttclass" id="chainName" value={chainName} onChange={handleInputChange} />
            {errors.chainName && <p className="error">{errors.chainName}</p>}
            <p className="inputtextttt">Chain ID</p>
            <input type="number" placeholder="Chain ID" className="inputttclass" id="chainID" value={chainID} onChange={handleInputChange} />
            {errors.chainID && <p className="error">{errors.chainID}</p>}
            <p className="inputtextttt">Chain Explorer</p>
            <input type="text" placeholder="Chain Explorer" className="inputttclass" id="chainExplorer" value={chainExplorer} onChange={handleInputChange} />
            {errors.chainExplorer && <p className="error">{errors.chainExplorer}</p>}
            <p className="inputtextttt">Standard</p>
            <input type="text" placeholder="Standard e.g(Erc20)" className="inputttclass" id="standard" value={standard} onChange={handleInputChange} />
            {errors.standard && <p className="error">{errors.standard}</p>}
            <p className="inputtextttt">RPC URL</p>
            <input type="text" placeholder="RPC URL" className="inputttclass" id="rpcURL" value={rpcURL} onChange={handleInputChange} />
            {errors.rpcURL && <p className="error">{errors.rpcURL}</p>}

            <div className="listedhead">
              <p className="availtab">Is Enabled</p>
              <label className="switch">
                <input type="checkbox" checked={isEnabled} onChange={() => setIsEnabled(!isEnabled)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="listedhead">
              <p className="availtab">Is Essential</p>
              <label className="switch">
                <input type="checkbox" checked={isEssential} onChange={() => setIsEssential(!isEssential)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="mainbuttdiv">
              <button className="buttt1 w-100" onClick={handleSubmit}>Add Chain</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addtoken;
